import { ADVERTISERS_DEMO, ROUTE_CAMPAIGNS } from "./constants";

export const isAdvertisersDemo = (id) =>
  Boolean(id) && ADVERTISERS_DEMO.includes(id);

export const isAdvertisersDemoAccount = ({
  advertiserID,
  agencyID,
  shopID,
} = {}) =>
  isAdvertisersDemo(advertiserID) ||
  isAdvertisersDemo(agencyID) ||
  isAdvertisersDemo(shopID);

export const getDefaultAppRoute = () => ROUTE_CAMPAIGNS;
